<div class="check-connection-container">
  <img
    [ngStyle]="isOnline ? { display: 'initial' } : { display: 'none' }"
    [alt]="connectionIconAlt"
    [src]="onlineConnectionIcon"
  />
  <img
    [ngStyle]="isOnline ? { display: 'none' } : { display: 'initial' }"
    [alt]="connectionIconAlt"
    [src]="offlineConnectionIcon"
  />
</div>
